import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useEffect } from 'react';
import { autorun, computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import { useMount } from 'ahooks';
import { useRootStore } from '@src/mobx-store/root-store';
import ZtServiceFactory from '@src/services/json';
import qs from '@xfe-team/utils/src/query-string-util';

class BaseStore {
  $globalStore;

  $history;

  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  $props;

  /**
   * 登录状态
   * @returns {*}
   */
  @observable isJinShanLogin = false;

  /**
   * 当前登录账号
   * @returns {undefined|*}
   */
  @computed
  get currentLoginAccount() {
    return window.XPASS?.$accountStore?.name;
  }

  @autobind
  exitAccount() {
    if (window.XPASS) {
      window.XPASS.exit().then(() => {
        window.location.reload();
      });
    }
  }

  @autobind
  login() {
    // 海外不支持onLoginSuccess回调
    window.XPASS.signin({
      onLoginSuccess: () => {
        window.onload();
      }
    });
  }

  @autobind
  exit() {
    this.exitAccount();
  }

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  @autobind
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  /**
   * 创建 search params 参数
   * @private
   */
  _createSearchParams() {
    let { search = '' } = this.$history.location;
    search = search.replace(/^\?/, '');
    useEffect(
      () => {
        if (search) {
          this.$searchParams = qs.parse(search);
        } else {
          this.$searchParams = {};
        }
      },
      [search]
    );
  }

  use(props) {
    this.$globalStore = useRootStore().globalStore;
    this.$props = props || {};
    this.$history = useHistory();
    /**
     * 路由参数
     * @type {History}
     */
    this.$routeParams = useParams();
    this.$routeMatch = useRouteMatch();
    this._createSearchParams();

    useMount(() => {
      autorun(() => {
        this.isJinShanLogin = window.XPASS?.$accountStore?.loginStatus || false;
      });
    });
  }
}

export default BaseStore;
